import { io } from "socket.io-client";

const SOCKET_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? "http://localhost:5000"
  : `${window.location.protocol}//${window.location.hostname}:5000`;

const socket = io(SOCKET_URL);

export default socket;